import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from '../animations/custom-animations';
import { ConfigService } from '../services/config.service';
import { ROUTES } from './sidebar-routes.config';
import { EventEmitter, Output } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { ToggleSharedService } from '../services/toggle-shared.service';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AdminSettingsService } from '../../pages/full-layout-page/admin-services/adminsettings-services.service';
import { EncryptionService } from 'app/pages/full-layout-page/admin-services/EncryptionService';

const encryptionService = new EncryptionService();

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  animations: customAnimations,
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('toggleIcon', { static: false }) toggleIcon:
    | ElementRef
    | undefined;
  public menuItems: any[] | undefined;
  depth: number | undefined;
  activeTitle: string | undefined;
  activeTitles: any[] = ['Content Management', 'Reports', 'Media Library'];
  expanded: boolean | undefined;
  nav_collapsed_open = false;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  userInfo: any;
  tenantName = 'Admin';
  firstDepth: number;
  secondDepth: number;
  isCollapsed = false;
  isTitleCollapse = false;
  toggleTitle = false;
  disablemenu: boolean = false;
  @Output() sidebarToggle = new EventEmitter<boolean>();
  permitted_tabs: Array<any> = [];
  isAdmin: boolean = false;
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private configService: ConfigService,
    private authService: AuthService,
    private toggleSharedService: ToggleSharedService,
    private toastr: ToastrService,
    private adminSettingsService: AdminSettingsService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
      this.firstDepth = 1;
      this.secondDepth = 2;
      this.expanded = true;
    }
  }

  /**
   * On ngOnInit method to get user details value in local storage.
   */
  async ngOnInit() {
    try {
      const response = await lastValueFrom(
        this.adminSettingsService.getLmsSettings('4201')
      );
      if (response && response['data']) {
        this.disablemenu = true;
      }
    } catch (error) {
      console.log(error);
      // this.toastr.error(error.error.error, '');
    }
    this.toggleSharedService.clipboardToggle$.subscribe(
      (isCollapsed: boolean) => {
        if (!this.isCollapsed) this.toggleSidebar();
      }
    );
    this.config = this.configService.templateConf;
    if (this.disablemenu) {
      this.userInfo = JSON.parse(localStorage.UserInfo).userdetails;
      // console.log(this.userInfo)
      if (this.userInfo?.role && this.userInfo.role != 'Admin') { }
      this.menuItems = ROUTES.filter(
        (item) =>
          item.identifier !== 'dashboard' &&
          item.identifier !== 'usermanagement'
      );
    } else {
      this.menuItems = ROUTES;
    }
    // console.log('MENU 1 ->', this.menuItems);

    if (localStorage.getItem('UserInfo') !== null) {
      this.userInfo = JSON.parse(localStorage.UserInfo).userdetails;
      if (this.userInfo.tenantName !== undefined) {
        this.tenantName = this.userInfo.tenantName;
      }
      if (this.config.layout.sidebar.backgroundColor === 'white') {
        this.logoUrl = 'assets/img/logo-dark.png';
      } else {
        this.logoUrl = 'assets/img/logo.png';
      }
      this.UserBasedMenuItems();
    }
    const storedUserDetails = localStorage.getItem('UserInfo');
    if (storedUserDetails) {
      const userDetails = JSON.parse(storedUserDetails).userdetails;
      this.isAdmin = userDetails.role === 'Admin';
    }
    if (!this.isAdmin) {
      const acl = localStorage.getItem('acl');
      const decryptedData = encryptionService.decrypt(acl);
      const parsedData = JSON.parse(decryptedData);
      parsedData.role.forEach(element => {
        this.permitted_tabs.push(element.id);
      });

      this.menuItems = this.filterRoutesByPermissions(this.menuItems , this.permitted_tabs)

    }
  }
  
  filterRoutesByPermissions(routes, permitted_tabs) {
    let modified = [];

    routes.forEach((route) => {
      const isParentPermitted = permitted_tabs.includes(route.pageid);

      let filteredSubmenu = [];
      if (route.submenu && route.submenu.length > 0) {
        filteredSubmenu = route.submenu.filter(submenuItem =>
          permitted_tabs.includes(submenuItem.pageid)
        );
      }

      if (isParentPermitted || filteredSubmenu.length > 0) {
        modified.push({
          ...route,
          submenu: filteredSubmenu
        });
      }
    });

    return modified;
  }
  async hideUnauthorizedTabs(): Promise<string[]> {
    return new Promise((resolve) => {
      const tabElements = document.querySelectorAll('[pageid]');
      const authorizedTabs: string[] = [];

      tabElements.forEach((tab: Element) => {
        const pageId = tab.getAttribute('pageid');
        if (pageId) {
          if (this.permitted_tabs.includes(pageId)) {
            authorizedTabs.push(pageId);
          } else {
            const parentElement = tab.parentNode;
            console.log(parentElement, "******")
            if (parentElement) {
              parentElement.removeChild(tab);
            }
          }
        }
      });

      console.log('Authorized Tabs:', authorizedTabs);

      resolve(authorizedTabs);
    });
  }
  /**
   * UserBasedMenuItems define the side bar menu items based on user role.
   */
  UserBasedMenuItems() {
    if (this.userInfo.roleInfo.type == 'userdefined') {
      this.menuItems = this.menuItems.filter((e) => {
        let inScenarios = ['usermanagement', 'contentmanagement', 'settings'];
        if (inScenarios.indexOf(e.identifier) === -1) {
          return e;
        }
      });

      console.log('MENU -->', this.menuItems);
    }
  }
  /**
   * on ngAfterViewInit method used to view the side bar on right or left.
   */
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.config.layout.sidebar.collapsed !== undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          // this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          // this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = true;
        } else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          // this.renderer.removeClass(this.toggleIcon.nativeElement, 'ft-toggle-left');
          // this.renderer.addClass(this.toggleIcon.nativeElement, 'ft-toggle-right');
          this.nav_collapsed_open = false;
        }
      }
    }, 0);
  }
  /**
   * toggleSlideInOut used to hide and view in side bar.
   */
  toggleSlideInOut() {
    this.expanded = !this.expanded;
  }
  /**
   * handleToggle used to define the active titles.
   * @param titles
   */
  handleToggle(titles: any) {
    this.activeTitles = titles;
  }

  // NGX Wizard - skip url change
  ngxWizardFunction(path: string) {
    if (path.indexOf('forms/ngx') !== -1) {
      this.router.navigate(['forms/ngx/wizard'], { skipLocationChange: false });
    }
  }
  toggleSidebar() {
    console.log(this.isCollapsed, this.isTitleCollapse, 'before');
    this.isCollapsed = !this.isCollapsed;
    this.isTitleCollapse = !this.isTitleCollapse;
    console.log(this.isCollapsed, this.isTitleCollapse, 'after');

    this.sidebarToggle.emit(this.isCollapsed);
  }

  toggleSidebarIN() {
    this.isCollapsed = false;
    this.isTitleCollapse = false;
    this.sidebarToggle.emit(this.isCollapsed);
  }

  toggleTitles() {
    this.toggleTitle = !this.toggleTitle;
  }

  logOut() {
    this.authService.logout().subscribe((success) => {
      if (success) {
        if (JSON.parse(localStorage.UserInfo).userdetails.role == '0') {
          localStorage.clear();
          this.router.navigate(['./login']);
        } else {
          if (
            JSON.parse(localStorage.UserInfo).userdetails.role == '1' &&
            JSON.parse(localStorage.UserInfo).userdetails.superAdmin
          ) {
            this.router.navigate(['./tenantchanging']);
          } else {
            this.router.navigate(['./login']);
            localStorage.clear();
          }
        }
      }
    });
  }
}
